<template>
  <vue-cookie-law ref="cookieLaw">
    <div>
      <h4>
        <strong>Vår policy för datahantering, integritet och cookies</strong>
      </h4>
      <p>
        Genom att surfa vidare på vår hemsida och använda våra tjänster så godkänner du till att vi samlar in data om dina besök. I vår integritetspolicy förklarar vi vilken data vi samlar in, varför vi samlar in den och vad vi använder den till.
        <a
          href="/policy"
          class="btn_close"
        >Läs mer...</a>
      </p>
    </div>
    <button type="button" class="close" aria-label="Close" @click="accept">
      <span aria-hidden="true">&times;</span>
    </button>
  </vue-cookie-law>
</template>

<script>
import VueCookieLaw from 'vue-cookie-law';

export default {
  name: 'cookie-law',
  components: {
    VueCookieLaw,
  },
  mounted() {},
  methods: {
    accept: function() {
      return this.$refs.cookieLaw.accept();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>